export default {
    _buttons: null,


    init() {
        this._button = document.querySelector('#fields-uploadFile');

        if(!(this._button)){
            return;
        }
        const uploadLabelcontainer = document.getElementById('fields-uploadFile--label');
        this._button.addEventListener('change',()=>{
            const filename = this._button.files[0].name;
            if(uploadLabelcontainer){
                const uploadLabel = uploadLabelcontainer.querySelector('input');
                uploadLabel.value = filename;
            }
        })
    }
}   